<template>
  <div class="cart-orders">
    <div class="order-shop">
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <span class="select" :class="{'selected':order.checked}" @click="checkItemAll" />
            <span class="shop-name">{{ order.shopName }}</span>
          </b-col>
          <b-col cols="4" style="text-align:left;">
            留言
            <b-form-input v-model="order.remark" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="order-items">
      <div class="order-item">
        <cart-order-item
          v-for="(item,index) in order.items"
          :key="index"
          :item="item"
          @removeItem="removeItem"
          @selectItem="selectItems"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CartOrderItem from './CartOrderItem'
export default {
  components: {
    'cart-order-item': CartOrderItem
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {

    selectItems (itemId) {
      console.log(itemId, this.order.shopId)
      this.$emit('checkItems', itemId, this.order.shopId)
    },
    checkItemAll () {
      this.$emit('selectOrder', this.order.shopId)
      this.$forceUpdate()
    },
    removeItem (itemId) {
      this.$emit('removeItem', itemId, this.order.shopId)
    }
  }
}
</script>
<style>
.col:first-child {
  text-align: left;
}
.order-shop span.select {
  margin-left: 3px;
}
.order-shop {
  background-color: #f5f5f5;
  border-bottom: 2px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.order-shop .select {
  text-align: left;
}
.order-shop .form-control {
  display: inline-block;
  padding-right: 0;
  outline: 0;
  width: 75%;
  border-radius: 0;
  height: 25px;
  line-height: 25px;
  text-align: left;
}
.order-shop .shop-name {
  margin-left: 15px;
}
.order-shop .col-7,
.col-4,
.col {
  height: 40px;
  font-weight: bold;
  line-height: 40px;
}
.order-shop .col-4 {
  padding-left: 0;
}
</style>
